import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _LoansForBusinessesFilledIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5215 3.15869C18.1404 3.18576 17.7661 3.33053 17.4561 3.59521L17.3125 3.72998C16.6052 4.47269 16.6053 5.65809 17.3125 6.40088L19.0518 8.22705C19.3981 8.59073 19.8787 8.80509 20.3906 8.80518C20.9025 8.80518 21.3831 8.59067 21.7295 8.22705L23 6.89209V19.5005C23 21.7096 21.2091 23.5005 19 23.5005H5C2.79086 23.5005 1 21.7096 1 19.5005V5.50049C1 3.29135 2.79086 1.50049 5 1.50049H18.5215V3.15869ZM16 12.7485C15.7748 13.0179 15.5207 13.2511 15.2568 13.4438C14.3853 14.0835 13.2383 14.4438 12.0176 14.4438C10.7967 14.4438 9.64991 14.0829 8.77832 13.4438C8.51065 13.2495 8.26098 13.0165 8.03516 12.7485V14.0786C8.03516 15.6928 9.81809 17.0005 12.0176 17.0005C14.217 17.0005 16 15.6928 16 14.0786V12.7485ZM12.0176 8.00049C9.81866 8.00049 8.03553 9.19056 8.03516 10.6587C8.03516 12.127 9.81843 13.3179 12.0176 13.3179C14.2166 13.3178 16 12.127 16 10.6587C15.9996 9.1906 14.2164 8.00056 12.0176 8.00049Z"
        fill={iconColor}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3909 0.500488C20.8712 0.500488 21.2605 0.909272 21.2605 1.41353V4.68751L21.5152 4.42009C21.8548 4.06352 22.4053 4.06352 22.7449 4.42009C23.0845 4.77665 23.0845 5.35476 22.7449 5.71132L21.0058 7.53741C20.8427 7.70864 20.6215 7.80484 20.3909 7.80484C20.1603 7.80484 19.9391 7.70864 19.776 7.53741L18.0369 5.71132C17.6973 5.35476 17.6973 4.77665 18.0369 4.42009C18.3765 4.06352 18.9271 4.06352 19.2667 4.42009L19.5214 4.68751V1.41353C19.5214 0.909272 19.9107 0.500488 20.3909 0.500488Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const LoansForBusinessesFilledIcon = assignWithoutSideEffects(_LoansForBusinessesFilledIcon, {
  componentId: 'LoansForBusinessesFilledIcon',
});

export default LoansForBusinessesFilledIcon;
